<header>
  <div class="m-header" [style.display]="this.headerStyle">
    <a class="mobile-menu" id="mobile-collapse1" href="javascript:"
      (click)="this.onNavCollapsedMob.emit()"><span></span></a>
    <a [routerLink]="['/home']" class="b-brand">
      <div class="b-bg">
        <i class="feather icon-command"></i>
      </div>
      <span class="b-title">Telchi</span>
    </a>
  </div>
  <a class="mobile-menu" [ngClass]="{ on: this.menuClass }" id="mobile-header" href="javascript:"
    (click)="toggleMobOption()"><i class="feather icon-more-horizontal"></i></a>
  <div class="collapse navbar-collapse px-4" [style.display]="this.collapseStyle">
    <app-nav-right class="ms-auto"></app-nav-right>
  </div>
</header>